export default __webpack_public_path__ + "static/media/wow.1dfb12fb.png";